import React from 'react'
import Markdown from 'react-markdown'

import './styles.css'

export default ({ children }) => {
  return (
    <Markdown
      className="markdown"
    >
      {children}
    </Markdown>
  )
}
